import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.542 10V4.79167C13.542 3.87119 12.7958 3.125 11.8753 3.125H3.95866C3.03818 3.125 2.29199 3.87119 2.29199 4.79167V14.7917C2.29199 15.9423 3.22473 16.875 4.37533 16.875H15.417M13.542 10V14.7917C13.542 15.9423 14.4747 16.875 15.6253 16.875C16.7759 16.875 17.7087 15.9423 17.7087 14.7917V11.6667C17.7087 10.7462 16.9625 10 16.042 10H13.542ZM5.62533 13.125H10.2087M5.62533 6.45833H10.2087V10.2083H5.62533V6.45833Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }